import sectionList from 'config/mapEditorSectionToUrl';
import entityTypes from 'config/entityTypes';
import { pick, get } from 'lodash';
import { addConditionalLogicActionToBlock } from 'utils/questionLogicUtils';

const { landing, survey, ty } = sectionList;
const { surveyItem, previewImg } = entityTypes;
const takeBlockAttrs = ({ id, attributes }) => ({ id, ...attributes });
const sortByOrder = (current, next) => current.section_order - next.section_order;

const filterItemBlocksBySection = (itemList, sectionName) =>
  itemList.filter((item) => {
    const isSurveyBlock = item.type === surveyItem;
    const sectionMatched = item.attributes.section === sectionName;

    return isSurveyBlock && sectionMatched;
  });

export const pickPreviewImage = (itemList) => {
  const image = itemList.find((item) => get(item, 'type') === previewImg);
  const imageAttributes = get(image, 'attributes', {});
  return pick(imageAttributes, ['updated_at', 'url']);
};

const getSectionItemBlocks = (itemList, sectionName) =>
  filterItemBlocksBySection(itemList, sectionName)
    .map(takeBlockAttrs)
    .sort(sortByOrder);

export const getLandingItemBlocks = (itemList) => getSectionItemBlocks(itemList, landing);

export const getQuestionItemBlocks = (itemList) =>
  getSectionItemBlocks(itemList, survey).map(addConditionalLogicActionToBlock);

export const getThankYouItemBlocks = (itemList) => getSectionItemBlocks(itemList, ty);

export const getHeaderItemBlocks = (itemList) => getSectionItemBlocks(itemList, 'headers');
